import {useMemo} from 'react'
import {MAIN_DOMAIN} from '../../brand'

const useTrustArc = () => {
    const setupTrustarcScript = (language) => {
        const tascript = document.createElement('script')
        tascript.src = `https://consent.trustarc.com/notice?domain=${MAIN_DOMAIN}&c=teconsent&gtm=1&js=nj&text=true&noticeType=bb&language=${language}`
        tascript.async = true
        document.head.appendChild(tascript)
    }

    const showTrustarcOverlay = () => {
        ;(function () {
            var teconsentSFCCCabled = document.querySelector('footer ul[role=list] #teconsent')
            if (teconsentSFCCCabled) {
                setTimeout(function () {
                    var sfcc_div = teconsentSFCCCabled.closest('ul')

                    var trust_l = document.createElement('li')
                    trust_l.appendChild(teconsentSFCCCabled)

                    var trust__list_pos_find = false
                    var trust_find_limit = 999
                    var trust_find_privacy = trust_find_limit
                    var trust_find_cookie = trust_find_limit

                    var trust__list_li = sfcc_div.getElementsByTagName('li')
                    var trust__list_li_node
                    for (var i = 0; i < trust__list_li.length; i++) {
                        trust__list_li_node = trust__list_li[i]
                        if (!trust__list_pos_find) {
                            if (trust__list_li_node.innerHTML.indexOf('Cookie') > -1) {
                                trust__list_pos_find = true
                                trust_find_cookie = i + 1
                            } else if (trust__list_li_node.innerHTML.indexOf('Privacy') > -1) {
                                trust__list_pos_find = true
                                trust_find_privacy = i + 1
                            }
                        }
                    }

                    if (!trust__list_pos_find) {
                        trust__list_li[trust__list_li.length - 1].insertAdjacentElement(
                            'beforebegin',
                            trust_l,
                        )
                    } else {
                        if (trust_find_cookie < trust_find_limit) {
                            trust__list_li[trust_find_cookie + 1].insertAdjacentElement(
                                'beforebegin',
                                trust_l,
                            )
                        } else {
                            trust__list_li[trust_find_privacy + 1].insertAdjacentElement(
                                'beforebegin',
                                trust_l,
                            )
                        }
                    }
                }, 1000)
            }
        })()
    }

    const listenTrustarcCMAPi = () => {
        var dispatched = {}

        // Wait for the PrivacyManagerAPI to become available
        var interval = setInterval(function () {
            if (window.PrivacyManagerAPI) {
                clearInterval(interval)

                // Directly request the current GDPR consent decision
                var decisionObj = window.PrivacyManagerAPI.callApi(
                    'getGDPRConsentDecision',
                    window.location.host,
                )

                processDecision(decisionObj && decisionObj.consentDecision)

                // Listen for future CMP updates (CMP sends updates via postMessage)
                window.addEventListener('message', onCMPMessage)
            }
        }, 50)

        // Handle CMP postMessage updates
        function onCMPMessage(event) {
            try {
                var data = JSON.parse(event.data)

                // Validate CMP message structure
                if (
                    (data.PrivacyManagerAPI &&
                        data.PrivacyManagerAPI.action === 'getConsentDecision') ||
                    (data.source && data.source === 'preference_manager')
                ) {
                    // Retrieve latest consent decision after notification
                    var newDecision = window.PrivacyManagerAPI.callApi(
                        'getGDPRConsentDecision',
                        window.location.host,
                    ).consentDecision

                    processDecision(newDecision)
                }
            } catch (err) {
                // Not a CMP-related message
            }
        }

        // Push consent changes to GTM only once per label
        function processDecision(decisions) {
            if (!decisions) return

            decisions.forEach(function (label) {
                if (!dispatched[label]) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                        event: 'GDPR Pref Allows ' + label,
                    })
                    dispatched[label] = true
                }
            })

            // Optional: hide consent banner if consent has been given
            if (decisions[0] !== 0) {
                var banners = document.querySelectorAll('#consent_blackbar')
                banners.forEach((banner) => (banner.style.display = 'none'))
            }
        }
    }

    const self = useMemo(
        () => ({
            setupTrustarcScript,
            showTrustarcOverlay,
            listenTrustarcCMAPi,
        }),
        [],
    )

    return self
}

export default useTrustArc
